import React from 'react';
import { Col, Row } from '@saucelabs/sl-component-grid';
import capitalize from 'lodash.capitalize';

import { Subscription } from '../../../records/Subscription';
import { amountSeparator, formatThousand } from '../../../utils/numbers';
import { projectsToMonthlyExecutions } from '../../../utils/plans';
import { PriceEntry } from './PriceEntry';
import Styles from './SubscriptionBoxes.styles';

interface ApiTestingSubscriptionBoxProps {
  subscription: Subscription
}
const ApiTestingSubscriptionBox: React.FC<ApiTestingSubscriptionBoxProps> = ({ subscription }) => {
  const cadence = subscription.getIntervalLabel();

  return (
    <>
      <Row>
        <Col xs={12}>
          <strong className="text-base">
            Current Plan: API Testing
          </strong>
        </Col>
      </Row>
      <Row>
        <Col
          key={subscription.id}
          xs={8}
        >
          <ul className={Styles.features}>
            <li className="text-gray-600">
              {`${capitalize(cadence) as string} plan`}
            </li>
            <li className="text-gray-600">
              <strong>
                {subscription.getAddonAmount()}
                {' '}
                projects,
                {' '}
                {formatThousand(projectsToMonthlyExecutions(
                  subscription.getAddonAmount(),
                  subscription.add_ons,
                ))}
                {' '}
                executions/mo
              </strong>
            </li>
            <li>
              <PriceEntry
                cadence={cadence}
                nextBillDay={subscription.displayNextBillDate()}
                price={amountSeparator(subscription.getMonthlyPrice())}
              />
            </li>
          </ul>
        </Col>

        <Col xs={4}>
          <div className="mt-0.5 ml-auto text-right">
            <div>
              Current Monthly Rate:
              {' '}
            </div>
            <strong className="text-base">
              {amountSeparator(subscription.getMonthlyPrice())}
            </strong>
          </div>
        </Col>
      </Row>
    </>
  );
};

export { ApiTestingSubscriptionBox };
